export default __webpack_public_path__ + "static/media/author-item-1.8c8e89fb.jpg";